package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings1 {
  internal val chapter_save: StringResource by lazy { init_chapter_save() }

  internal val check_update: StringResource by lazy { init_check_update() }

  internal val checking_for_updates: StringResource by lazy { init_checking_for_updates() }

  internal val chidon_of: StringResource by lazy { init_chidon_of() }

  internal val choose_aliyah: StringResource by lazy { init_choose_aliyah() }

  internal val choose_name_for_completion: StringResource by lazy {
      init_choose_name_for_completion() }

  internal val choose_name_for_mikud: StringResource by lazy { init_choose_name_for_mikud() }

  internal val choose_questions_topic: StringResource by lazy { init_choose_questions_topic() }

  internal val chumash: StringResource by lazy { init_chumash() }

  internal val chumash_parashat_format: StringResource by lazy { init_chumash_parashat_format() }

  internal val clear_text: StringResource by lazy { init_clear_text() }

  internal val click_on_words_to_be_omitted: StringResource by lazy {
      init_click_on_words_to_be_omitted() }

  internal val click_to_update: StringResource by lazy { init_click_to_update() }

  internal val close: StringResource by lazy { init_close() }

  internal val complete_chapter: StringResource by lazy { init_complete_chapter() }

  internal val complete_chapter_title: StringResource by lazy { init_complete_chapter_title() }

  internal val complete_verse: StringResource by lazy { init_complete_verse() }

  internal val confirm_exit: StringResource by lazy { init_confirm_exit() }

  internal val consume: StringResource by lazy { init_consume() }

  internal val copied_to_clipboard: StringResource by lazy { init_copied_to_clipboard() }

  internal val copy_only_highlights: StringResource by lazy { init_copy_only_highlights() }

  internal val copy_options: StringResource by lazy { init_copy_options() }

  internal val copy_pairs: StringResource by lazy { init_copy_pairs() }

  internal val copy_search_result: StringResource by lazy { init_copy_search_result() }

  internal val copy_text: StringResource by lazy { init_copy_text() }

  internal val create_completions: StringResource by lazy { init_create_completions() }

  internal val create_pairs: StringResource by lazy { init_create_pairs() }

  internal val create_your_own_qna: StringResource by lazy { init_create_your_own_qna() }

  internal val custom_mikud_saved: StringResource by lazy { init_custom_mikud_saved() }

  internal val deceased_name: StringResource by lazy { init_deceased_name() }

  internal val decrease_text_size: StringResource by lazy { init_decrease_text_size() }

  internal val default_open_questions_number_per_page: StringResource by lazy {
      init_default_open_questions_number_per_page() }

  internal val delete: StringResource by lazy { init_delete() }

  internal val delete_custom_mikud: StringResource by lazy { init_delete_custom_mikud() }

  internal val delete_full_version: StringResource by lazy { init_delete_full_version() }

  internal val delete_mikud: StringResource by lazy { init_delete_mikud() }

  internal val deselect_all: StringResource by lazy { init_deselect_all() }

  internal val dice: StringResource by lazy { init_dice() }

  internal val different_verses: StringResource by lazy { init_different_verses() }

  internal val do_you_want_to_make_purchase: StringResource by lazy {
      init_do_you_want_to_make_purchase() }

  internal val donate: StringResource by lazy { init_donate() }

  internal val dont_show_again: StringResource by lazy { init_dont_show_again() }

  internal val double_format: StringResource by lazy { init_double_format() }

  internal val download_gendered: StringResource by lazy { init_download_gendered() }

  internal val downloaded_from_server: StringResource by lazy { init_downloaded_from_server() }

  internal val downloading_data: StringResource by lazy { init_downloading_data() }

  internal val downloading_data_format: StringResource by lazy { init_downloading_data_format() }

  internal val draggable_item_regular_click: StringResource by lazy {
      init_draggable_item_regular_click() }

  internal val dragging_done: StringResource by lazy { init_dragging_done() }

  internal val dragging_reset: StringResource by lazy { init_dragging_reset() }

  internal fun values(): List<StringResource> = listOf(chapter_save, check_update,
      checking_for_updates, chidon_of, choose_aliyah, choose_name_for_completion,
      choose_name_for_mikud, choose_questions_topic, chumash, chumash_parashat_format, clear_text,
      click_on_words_to_be_omitted, click_to_update, close, complete_chapter,
      complete_chapter_title, complete_verse, confirm_exit, consume, copied_to_clipboard,
      copy_only_highlights, copy_options, copy_pairs, copy_search_result, copy_text,
      create_completions, create_pairs, create_your_own_qna, custom_mikud_saved, deceased_name,
      decrease_text_size, default_open_questions_number_per_page, delete, delete_custom_mikud,
      delete_full_version, delete_mikud, deselect_all, dice, different_verses,
      do_you_want_to_make_purchase, donate, dont_show_again, double_format, download_gendered,
      downloaded_from_server, downloading_data, downloading_data_format,
      draggable_item_regular_click, dragging_done, dragging_reset)
}

private fun init_chapter_save(): StringResource = StringResource(key = "chapter_save", loader =
    stringsLoader)

private fun init_check_update(): StringResource = StringResource(key = "check_update", loader =
    stringsLoader)

private fun init_checking_for_updates(): StringResource = StringResource(key =
    "checking_for_updates", loader = stringsLoader)

private fun init_chidon_of(): StringResource = StringResource(key = "chidon_of", loader =
    stringsLoader)

private fun init_choose_aliyah(): StringResource = StringResource(key = "choose_aliyah", loader =
    stringsLoader)

private fun init_choose_name_for_completion(): StringResource = StringResource(key =
    "choose_name_for_completion", loader = stringsLoader)

private fun init_choose_name_for_mikud(): StringResource = StringResource(key =
    "choose_name_for_mikud", loader = stringsLoader)

private fun init_choose_questions_topic(): StringResource = StringResource(key =
    "choose_questions_topic", loader = stringsLoader)

private fun init_chumash(): StringResource = StringResource(key = "chumash", loader = stringsLoader)

private fun init_chumash_parashat_format(): StringResource = StringResource(key =
    "chumash_parashat_format", loader = stringsLoader)

private fun init_clear_text(): StringResource = StringResource(key = "clear_text", loader =
    stringsLoader)

private fun init_click_on_words_to_be_omitted(): StringResource = StringResource(key =
    "click_on_words_to_be_omitted", loader = stringsLoader)

private fun init_click_to_update(): StringResource = StringResource(key = "click_to_update", loader
    = stringsLoader)

private fun init_close(): StringResource = StringResource(key = "close", loader = stringsLoader)

private fun init_complete_chapter(): StringResource = StringResource(key = "complete_chapter",
    loader = stringsLoader)

private fun init_complete_chapter_title(): StringResource = StringResource(key =
    "complete_chapter_title", loader = stringsLoader)

private fun init_complete_verse(): StringResource = StringResource(key = "complete_verse", loader =
    stringsLoader)

private fun init_confirm_exit(): StringResource = StringResource(key = "confirm_exit", loader =
    stringsLoader)

private fun init_consume(): StringResource = StringResource(key = "consume", loader = stringsLoader)

private fun init_copied_to_clipboard(): StringResource = StringResource(key = "copied_to_clipboard",
    loader = stringsLoader)

private fun init_copy_only_highlights(): StringResource = StringResource(key =
    "copy_only_highlights", loader = stringsLoader)

private fun init_copy_options(): StringResource = StringResource(key = "copy_options", loader =
    stringsLoader)

private fun init_copy_pairs(): StringResource = StringResource(key = "copy_pairs", loader =
    stringsLoader)

private fun init_copy_search_result(): StringResource = StringResource(key = "copy_search_result",
    loader = stringsLoader)

private fun init_copy_text(): StringResource = StringResource(key = "copy_text", loader =
    stringsLoader)

private fun init_create_completions(): StringResource = StringResource(key = "create_completions",
    loader = stringsLoader)

private fun init_create_pairs(): StringResource = StringResource(key = "create_pairs", loader =
    stringsLoader)

private fun init_create_your_own_qna(): StringResource = StringResource(key = "create_your_own_qna",
    loader = stringsLoader)

private fun init_custom_mikud_saved(): StringResource = StringResource(key = "custom_mikud_saved",
    loader = stringsLoader)

private fun init_deceased_name(): StringResource = StringResource(key = "deceased_name", loader =
    stringsLoader)

private fun init_decrease_text_size(): StringResource = StringResource(key = "decrease_text_size",
    loader = stringsLoader)

private fun init_default_open_questions_number_per_page(): StringResource = StringResource(key =
    "default_open_questions_number_per_page", loader = stringsLoader)

private fun init_delete(): StringResource = StringResource(key = "delete", loader = stringsLoader)

private fun init_delete_custom_mikud(): StringResource = StringResource(key = "delete_custom_mikud",
    loader = stringsLoader)

private fun init_delete_full_version(): StringResource = StringResource(key = "delete_full_version",
    loader = stringsLoader)

private fun init_delete_mikud(): StringResource = StringResource(key = "delete_mikud", loader =
    stringsLoader)

private fun init_deselect_all(): StringResource = StringResource(key = "deselect_all", loader =
    stringsLoader)

private fun init_dice(): StringResource = StringResource(key = "dice", loader = stringsLoader)

private fun init_different_verses(): StringResource = StringResource(key = "different_verses",
    loader = stringsLoader)

private fun init_do_you_want_to_make_purchase(): StringResource = StringResource(key =
    "do_you_want_to_make_purchase", loader = stringsLoader)

private fun init_donate(): StringResource = StringResource(key = "donate", loader = stringsLoader)

private fun init_dont_show_again(): StringResource = StringResource(key = "dont_show_again", loader
    = stringsLoader)

private fun init_double_format(): StringResource = StringResource(key = "double_format", loader =
    stringsLoader)

private fun init_download_gendered(): StringResource = StringResource(key = "download_gendered",
    loader = stringsLoader)

private fun init_downloaded_from_server(): StringResource = StringResource(key =
    "downloaded_from_server", loader = stringsLoader)

private fun init_downloading_data(): StringResource = StringResource(key = "downloading_data",
    loader = stringsLoader)

private fun init_downloading_data_format(): StringResource = StringResource(key =
    "downloading_data_format", loader = stringsLoader)

private fun init_draggable_item_regular_click(): StringResource = StringResource(key =
    "draggable_item_regular_click", loader = stringsLoader)

private fun init_dragging_done(): StringResource = StringResource(key = "dragging_done", loader =
    stringsLoader)

private fun init_dragging_reset(): StringResource = StringResource(key = "dragging_reset", loader =
    stringsLoader)

public actual val SharedRes.strings.chapter_save: StringResource
  get() = CommonMainStrings1.chapter_save

public actual val SharedRes.strings.check_update: StringResource
  get() = CommonMainStrings1.check_update

public actual val SharedRes.strings.checking_for_updates: StringResource
  get() = CommonMainStrings1.checking_for_updates

public actual val SharedRes.strings.chidon_of: StringResource
  get() = CommonMainStrings1.chidon_of

public actual val SharedRes.strings.choose_aliyah: StringResource
  get() = CommonMainStrings1.choose_aliyah

public actual val SharedRes.strings.choose_name_for_completion: StringResource
  get() = CommonMainStrings1.choose_name_for_completion

public actual val SharedRes.strings.choose_name_for_mikud: StringResource
  get() = CommonMainStrings1.choose_name_for_mikud

public actual val SharedRes.strings.choose_questions_topic: StringResource
  get() = CommonMainStrings1.choose_questions_topic

public actual val SharedRes.strings.chumash: StringResource
  get() = CommonMainStrings1.chumash

public actual val SharedRes.strings.chumash_parashat_format: StringResource
  get() = CommonMainStrings1.chumash_parashat_format

public actual val SharedRes.strings.clear_text: StringResource
  get() = CommonMainStrings1.clear_text

public actual val SharedRes.strings.click_on_words_to_be_omitted: StringResource
  get() = CommonMainStrings1.click_on_words_to_be_omitted

public actual val SharedRes.strings.click_to_update: StringResource
  get() = CommonMainStrings1.click_to_update

public actual val SharedRes.strings.close: StringResource
  get() = CommonMainStrings1.close

public actual val SharedRes.strings.complete_chapter: StringResource
  get() = CommonMainStrings1.complete_chapter

public actual val SharedRes.strings.complete_chapter_title: StringResource
  get() = CommonMainStrings1.complete_chapter_title

public actual val SharedRes.strings.complete_verse: StringResource
  get() = CommonMainStrings1.complete_verse

public actual val SharedRes.strings.confirm_exit: StringResource
  get() = CommonMainStrings1.confirm_exit

public actual val SharedRes.strings.consume: StringResource
  get() = CommonMainStrings1.consume

public actual val SharedRes.strings.copied_to_clipboard: StringResource
  get() = CommonMainStrings1.copied_to_clipboard

public actual val SharedRes.strings.copy_only_highlights: StringResource
  get() = CommonMainStrings1.copy_only_highlights

public actual val SharedRes.strings.copy_options: StringResource
  get() = CommonMainStrings1.copy_options

public actual val SharedRes.strings.copy_pairs: StringResource
  get() = CommonMainStrings1.copy_pairs

public actual val SharedRes.strings.copy_search_result: StringResource
  get() = CommonMainStrings1.copy_search_result

public actual val SharedRes.strings.copy_text: StringResource
  get() = CommonMainStrings1.copy_text

public actual val SharedRes.strings.create_completions: StringResource
  get() = CommonMainStrings1.create_completions

public actual val SharedRes.strings.create_pairs: StringResource
  get() = CommonMainStrings1.create_pairs

public actual val SharedRes.strings.create_your_own_qna: StringResource
  get() = CommonMainStrings1.create_your_own_qna

public actual val SharedRes.strings.custom_mikud_saved: StringResource
  get() = CommonMainStrings1.custom_mikud_saved

public actual val SharedRes.strings.deceased_name: StringResource
  get() = CommonMainStrings1.deceased_name

public actual val SharedRes.strings.decrease_text_size: StringResource
  get() = CommonMainStrings1.decrease_text_size

public actual val SharedRes.strings.default_open_questions_number_per_page: StringResource
  get() = CommonMainStrings1.default_open_questions_number_per_page

public actual val SharedRes.strings.delete: StringResource
  get() = CommonMainStrings1.delete

public actual val SharedRes.strings.delete_custom_mikud: StringResource
  get() = CommonMainStrings1.delete_custom_mikud

public actual val SharedRes.strings.delete_full_version: StringResource
  get() = CommonMainStrings1.delete_full_version

public actual val SharedRes.strings.delete_mikud: StringResource
  get() = CommonMainStrings1.delete_mikud

public actual val SharedRes.strings.deselect_all: StringResource
  get() = CommonMainStrings1.deselect_all

public actual val SharedRes.strings.dice: StringResource
  get() = CommonMainStrings1.dice

public actual val SharedRes.strings.different_verses: StringResource
  get() = CommonMainStrings1.different_verses

public actual val SharedRes.strings.do_you_want_to_make_purchase: StringResource
  get() = CommonMainStrings1.do_you_want_to_make_purchase

public actual val SharedRes.strings.donate: StringResource
  get() = CommonMainStrings1.donate

public actual val SharedRes.strings.dont_show_again: StringResource
  get() = CommonMainStrings1.dont_show_again

public actual val SharedRes.strings.double_format: StringResource
  get() = CommonMainStrings1.double_format

public actual val SharedRes.strings.download_gendered: StringResource
  get() = CommonMainStrings1.download_gendered

public actual val SharedRes.strings.downloaded_from_server: StringResource
  get() = CommonMainStrings1.downloaded_from_server

public actual val SharedRes.strings.downloading_data: StringResource
  get() = CommonMainStrings1.downloading_data

public actual val SharedRes.strings.downloading_data_format: StringResource
  get() = CommonMainStrings1.downloading_data_format

public actual val SharedRes.strings.draggable_item_regular_click: StringResource
  get() = CommonMainStrings1.draggable_item_regular_click

public actual val SharedRes.strings.dragging_done: StringResource
  get() = CommonMainStrings1.dragging_done

public actual val SharedRes.strings.dragging_reset: StringResource
  get() = CommonMainStrings1.dragging_reset
